const data = {
  category: [
    {
      name: "Arco en C",
      value: "arco_en_c",
      shipping_price: 8000,
      installation_price: 240,
      weight: 3,
      size: "large",
      requiresSpecialHandling: true,
      equipmentFactor: 1.5, // Large equipment factor
      allowedVehicles: ["camion_pequeno", "camion_mediano", "camion_grande", "avion"]
    },
    {
      name: "RX Estacionario",
      value: "rx_estacionario",
      shipping_price: 7800,
      installation_price: 1620,
      weight: 3,
      size: "large",
      requiresSpecialHandling: true,
      equipmentFactor: 1.5, // Large equipment factor
        allowedVehicles: ["camion_pequeno", "camion_mediano", "camion_grande", "avion"]
    },
    {
      name: "Mamografo",
      value: "mamografo",
      shipping_price: 8000,
      installation_price: 1920,
      weight: 3,
      size: "large",
      requiresSpecialHandling: true,
      equipmentFactor: 1.5, // Large equipment factor
        allowedVehicles: ["camion_pequeno", "camion_mediano", "camion_grande", "avion"]
    },
    {
      name: "Digitalizador",
      value: "digitalizador",
      shipping_price: 3000,
      installation_price: 0,
      weight: 1,
      size: "medium",
      requiresSpecialHandling: false,
      equipmentFactor: 1.2, // Medium equipment factor
      allowedVehicles: ["auto", "pickup", "camion_pequeno", "camion_mediano", "camion_grande", "barco", "avion"]
    },
    {
      name: "Ecografo M",
      value: "ecografo_m",
      shipping_price: 1300,
      installation_price: 0,
      weight: 1,
      size: "medium",
      requiresSpecialHandling: false,
      equipmentFactor: 1.2, // Medium equipment factor
      allowedVehicles: ["auto", "pickup", "camion_pequeno", "camion_mediano", "camion_grande", "barco", "avion"]
    },
    {
      name: "Tomografo/CT",
      value: "tomografo_listo",
      shipping_price: 15600,
      installation_price: 3600,
      weight: 3,
      size: "large",
      requiresSpecialHandling: true,
      equipmentFactor: 1.5, // Large equipment factor
        allowedVehicles: ["camion_pequeno", "camion_mediano", "camion_grande", "avion"]
    },
    {
      name: "RSM",
      value: "rsm",
      shipping_price: 25000,
      installation_price: 8900,
      weight: 3,
      size: "large",
      requiresSpecialHandling: true,
      equipmentFactor: 1.8, // Extra large equipment factor
        allowedVehicles: ["camion_pequeno", "camion_mediano", "camion_grande", "avion"]
    },
    {
      name: "RX Movil",
      value: "rx_movil",
      shipping_price: 3000,
      installation_price: 0,
      weight: 2,
      size: "medium",
      requiresSpecialHandling: false,
      equipmentFactor: 1.2, // Medium equipment factor
      allowedVehicles: ["pickup", "camion_pequeno", "camion_mediano", "camion_grande", "barco", "avion"]
    },
    {
      name: "RX Portatil",
      value: "rx_portatil",
      shipping_price: 1000,
      installation_price: 0,
      weight: 0,
      size: "small",
      requiresSpecialHandling: false,
      equipmentFactor: 1.0, // Small equipment factor
      allowedVehicles: ["auto", "pickup", "camion_pequeno", "camion_mediano", "camion_grande", "barco", "avion"]
    },
    {
      name: "Ecografo P",
      value: "ecografo_p",
      shipping_price: 1000,
      installation_price: 0,
      weight: 0,
      size: "small",
      requiresSpecialHandling: false,
      equipmentFactor: 1.0, // Small equipment factor
      allowedVehicles: ["auto", "pickup", "camion_pequeno", "camion_mediano", "camion_grande", "barco", "avion"]
    },
    {
      name: "Flat panel",
      value: "flat_panel",
      shipping_price: 700,
      installation_price: 0,
      weight: 0,
      size: "small",
      requiresSpecialHandling: false,
      equipmentFactor: 1.0, // Small equipment factor
      allowedVehicles: ["auto", "pickup", "camion_pequeno", "camion_mediano", "camion_grande", "barco", "avion"]
    },
    {
      name: "Carrito",
      value: "carrito",
      shipping_price: 500,
      installation_price: 0,
      weight: 1,
      size: "medium",
      requiresSpecialHandling: false,
      equipmentFactor: 1.2, // Medium equipment factor
      allowedVehicles: ["auto", "pickup", "camion_pequeno", "camion_mediano", "camion_grande", "barco", "avion"]
    },
    {
      name: "Partes",
      value: "partes",
      shipping_price: 200,
      installation_price: 0,
      weight: 0,
      size: "small",
      requiresSpecialHandling: false,
      equipmentFactor: 1.0, // Small equipment factor
      allowedVehicles: ["auto", "pickup", "camion_pequeno", "camion_mediano", "camion_grande", "barco", "avion"]
    },
    {
      name: "Kit Rx portatil",
      value: "kit_rx_portatil",
      shipping_price: 2241,
      installation_price: 0,
      weight: 1,
      size: "medium",
      requiresSpecialHandling: false,
      equipmentFactor: 1.2, // Medium equipment factor
      allowedVehicles: ["auto", "pickup", "camion_pequeno", "camion_mediano", "camion_grande", "barco", "avion"]
    },
  ],
  state: [
    { name: "Barinas", value: "barinas", distance: 0, shipping_day: 0 },
    { name: "Merida", value: "merida", distance: 170, shipping_day: 1 },
    { name: "Portuguesa", value: "portuguesa", distance: 170, shipping_day: 1 },
    { name: "Trujillo", value: "trujillo", distance: 252, shipping_day: 1 },
    { name: "Apure", value: "apure", distance: 302, shipping_day: 1 },
    { name: "Cojedes", value: "cojedes", distance: 311, shipping_day: 2 },
    { name: "Yaracuy", value: "yaracuy", distance: 314, shipping_day: 2 },
    { name: "Lara", value: "lara", distance: 315, shipping_day: 2 },
    { name: "Tachira", value: "tachira", distance: 331, shipping_day: 2 },
    { name: "Carabobo", value: "carabobo", distance: 337, shipping_day: 2 },
    { name: "Aragua", value: "aragua", distance: 392, shipping_day: 2 },
    { name: "Guarico", value: "guarico", distance: 500, shipping_day: 2 },
    { name: "Capital", value: "capital", distance: 515, shipping_day: 2 },
    { name: "Miranda", value: "miranda", distance: 555, shipping_day: 3 },
    { name: "Zulia", value: "zulia", distance: 577, shipping_day: 3 },
    { name: "Vargas", value: "vargas", distance: 600, shipping_day: 3 },
    { name: "Falcon", value: "falcon", distance: 689, shipping_day: 3 },
    {
      name: "Federal Dependencies",
      value: "federal_dependencies",
      distance: 700,
      shipping_day: 3,
    },
    { name: "Amazonas", value: "amazonas", distance: 709, shipping_day: 3 },
    { name: "Anzoategui", value: "anzoategui", distance: 842, shipping_day: 3 },
    { name: "Sucre", value: "sucre", distance: 910, shipping_day: 3 },
    {
      name: "Nueva esparta",
      value: "nueva_esparta",
      distance: 979,
      shipping_day: 3,
    },
    { name: "Monagas", value: "monagas", distance: 1000, shipping_day: 3 },
    {
      name: "Delta Amacuro",
      value: "delta_amacuro",
      distance: 1106,
      shipping_day: 3,
    },
    { name: "Bolivar", value: "bolivar", distance: 1207, shipping_day: 3 },
    { name: "Other", value: "other", distance: 0, shipping_day: 0 },
  ],
  vehicle: [
    { name: "Auto", value: "auto", price: 0.25, capacity: "light", maxWeight: 1, maxItems: 2, basePrice: 100 },
    { name: "Pickup", value: "pickup", price: 0.40, capacity: "medium", maxWeight: 2, maxItems: 3, basePrice: 200 },
    { name: "Camion Pequeño", value: "camion_pequeno", price: 0.80, capacity: "heavy", maxWeight: 3, maxItems: 4, basePrice: 500 },
    { name: "Camion Mediano", value: "camion_mediano", price: 1.00, capacity: "heavy", maxWeight: 3, maxItems: 6, basePrice: 700 },
    { name: "Camion Grande", value: "camion_grande", price: 1.20, capacity: "heavy", maxWeight: 3, maxItems: 8, basePrice: 1000 },
    { name: "Avión", value: "avion", price: 1.50, capacity: "unlimited", maxWeight: 999, maxItems: 999, basePrice: 2000 },
  ],
  extra: [
    { name: "monta_cargas", price: 300 },
    { name: "ferry", price: 300 },
  ],
};

let selectedVehicle,
  selectedState = "barinas", // Set Barinas as default
  selectedOriginState = "barinas", // Set Barinas as default origin
  stateChoices,
  vehicleChoices,
  categoryChoices;
const ferryCheckbox = document.getElementById("ferry");
const montaCargasCheckbox = document.getElementById("load_lifter");
const installationCheckbox = document.getElementById("installation");
const distanceInput = document.getElementById("distance");

if (distanceInput && distanceInput.parentElement) {
  distanceInput.parentElement.style.display = "none";
}

function getShippingDay(distance) {
  if (distance === 0) return 0;
  if (distance > 0 && distance <= 300) {
    return 1;
  } else if (distance > 300 && distance <= 515) {
    return 2;
  } else if (distance > 515 && distance <= 1250) {
    return 3;
  } else {
    return -1; // or throw error if out of range
  }
}

function showValidationError(message) {
  const resultsElement = document.getElementById("results");
  if (resultsElement) {
    resultsElement.innerHTML = `
      <div class="shipping_result">
        <div class="validation_error" style="background-color: #ffebee; color: #c62828; padding: 15px; border-radius: 5px; margin-bottom: 10px; border-left: 4px solid #c62828;">
          <strong>⚠️ Error de Validación:</strong> ${message}
        </div>
      </div>
    `;
    resultsElement.style.display = "block";
  }
}

function showValidationWarning(message) {
  const resultsElement = document.getElementById("results");
  if (resultsElement) {
    // Check if there's already a results section, if so, prepend the warning
    const existingContent = resultsElement.innerHTML;
    const warningHTML = `
      <div class="shipping_result">
        <div class="validation_warning" style="background-color: #fff3cd; color: #856404; padding: 15px; border-radius: 5px; margin-bottom: 10px; border-left: 4px solid #ffc107;">
          ${message}
        </div>
      </div>
    `;
    
    if (existingContent.includes('shipping_result')) {
      // Insert warning at the beginning of existing results
      resultsElement.innerHTML = warningHTML + existingContent;
    } else {
      // Just show the warning
      resultsElement.innerHTML = warningHTML;
    }
    resultsElement.style.display = "block";
  }
}

function validateVehicleCapacity(selectedCats, vehicle) {
  const incompatibleEquipment = [];
  const capacityIssues = [];
  
  selectedCats.forEach(catVal => {
    const cat = data.category.find(c => c.value === catVal);
    if (cat && !cat.allowedVehicles.includes(vehicle.value)) {
      incompatibleEquipment.push(cat.name);
    }
  });
  
  // Check capacity issues for ground vehicles
  if (vehicle.value !== "avion") {
    const capacityInfo = calculateCapacityUsage(selectedCats, vehicle);
    if (capacityInfo.isOverloaded) {
      capacityIssues.push(`Capacidad excedida: ${capacityInfo.totalItems}/${capacityInfo.maxItems} equipos, ${capacityInfo.totalWeight}/${capacityInfo.maxWeight} peso`);
    }
  }
  
  // Show warnings but don't prevent calculation
  if (incompatibleEquipment.length > 0) {
    const equipmentList = incompatibleEquipment.join(", ");
    showValidationWarning(`⚠️ Advertencia de Compatibilidad: El vehículo "${vehicle.name}" no está diseñado para transportar: ${equipmentList}. 
    Esto puede requerir embalaje especial o vehículos adicionales.`);
  }
  
  if (capacityIssues.length > 0) {
    showValidationWarning(`⚠️ Advertencia de Capacidad: ${capacityIssues.join(", ")}. 
    Se recomienda usar un vehículo más grande o múltiples vehículos.`);
  }
  
  return true; // Always allow calculation, just show warnings
}

function calculateCapacityUsage(selectedEquipment, vehicle) {
  const equipment = data.category.filter(cat => selectedEquipment.includes(cat.value));
  const totalWeight = equipment.reduce((sum, eq) => sum + eq.weight, 0);
  const totalItems = equipment.length;
  
  // For avion (unlimited capacity), don't apply capacity restrictions
  if (vehicle.value === "avion") {
    return {
      totalWeight,
      totalItems,
      maxWeight: 999,
      maxItems: 999,
      weightUsage: 0,
      itemUsage: 0,
      isOverloaded: false,
      needsAdditionalVehicle: false
    };
  }
  
  const maxWeight = vehicle.maxWeight;
  const maxItems = vehicle.maxItems;
  
  return {
    totalWeight,
    totalItems,
    maxWeight,
    maxItems,
    weightUsage: (totalWeight / maxWeight) * 100,
    itemUsage: (totalItems / maxItems) * 100,
    isOverloaded: totalWeight > maxWeight || totalItems > maxItems,
    needsAdditionalVehicle: totalItems > maxItems
  };
}

function calculateRequiredVehicles(selectedEquipment, vehicle) {
  const equipment = data.category.filter(cat => selectedEquipment.includes(cat.value));
  const totalItems = equipment.length;
  
  // For avion (unlimited capacity), always need only 1 vehicle
  if (vehicle.value === "avion") {
    return 1;
  }
  
  const maxItems = vehicle.maxItems;
  return Math.ceil(totalItems / maxItems);
}

function detectProductCategory() {
  try {
    const productTag = document.querySelector('#ProductInfo-template--19376132686069__main .product-tags__tag');
    if (!productTag) return null;
    
    const tagText = productTag.textContent.trim().toLowerCase();
    
    // Robust category detection with multiple variations
    const categoryMappings = {
      'arco en c': 'arco_en_c',
      'arcos en c': 'arco_en_c',
      'arco c': 'arco_en_c',
      'rx estacionario': 'rx_estacionario',
      'rayos x estacionario': 'rx_estacionario',
      'rayos x estacionarios': 'rx_estacionario',
      'rx estacionarios': 'rx_estacionario',
      'mamografo': 'mamografo',
      'mamografos': 'mamografo',
      'mamógrafo': 'mamografo',
      'mamógrafos': 'mamografo',
      'tomografo': 'tomografo_listo',
      'tomografos': 'tomografo_listo',
      'tomógrafo': 'tomografo_listo',
      'tomógrafos': 'tomografo_listo',
      'ct': 'tomografo_listo',
      'scanner': 'tomografo_listo',
      'digitalizador': 'digitalizador',
      'digitalizadores': 'digitalizador',
      'ecografo m': 'ecografo_m',
      'ecografos m': 'ecografo_m',
      'ecógrafo m': 'ecografo_m',
      'ecógrafos m': 'ecografo_m',
      'rsm': 'rsm',
      'rx movil': 'rx_movil',
      'rayos x movil': 'rx_movil',
      'rayos x móvil': 'rx_movil',
      'rx móvil': 'rx_movil',
      'rx portatil': 'rx_portatil',
      'rayos x portatil': 'rx_portatil',
      'rayos x portátil': 'rx_portatil',
      'rx portátil': 'rx_portatil',
      'ecografo p': 'ecografo_p',
      'ecografos p': 'ecografo_p',
      'ecógrafo p': 'ecografo_p',
      'ecógrafos p': 'ecografo_p',
      'flat panel': 'flat_panel',
      'flat panels': 'flat_panel',
      'carrito': 'carrito',
      'carritos': 'carrito',
      'partes': 'partes',
      'piezas': 'partes',
      'kit rx portatil': 'kit_rx_portatil',
      'kit rx portátil': 'kit_rx_portatil',
      'kit rayos x portatil': 'kit_rx_portatil',
      'kit rayos x portátil': 'kit_rx_portatil'
    };
    
    // Check for exact matches first
    if (categoryMappings[tagText]) {
      return categoryMappings[tagText];
    }
    
    // Check for partial matches
    for (const [key, value] of Object.entries(categoryMappings)) {
      if (tagText.includes(key) || key.includes(tagText)) {
        return value;
      }
    }
    
    return null;
  } catch (error) {
    console.log('Error detecting product category:', error);
    return null;
  }
}

function populateSelect(id, options, placeholder) {
  const select = document.getElementById(id);
  if (!select) {
    console.warn(`Element with id "${id}" not found`);
    return;
  }

  // Clear existing options
  select.innerHTML = '';
  
  // Add placeholder option first
  const placeholderOption = document.createElement("option");
  placeholderOption.value = "";
  placeholderOption.textContent = placeholder;
  placeholderOption.disabled = true;
  placeholderOption.selected = true;
  select.appendChild(placeholderOption);
  
  options.forEach((opt) => {
    const o = document.createElement("option");
    o.value = opt.value;
    o.textContent = opt.name;
    select.appendChild(o);
  });

  let choices = null;
  
  if (typeof Choices !== 'undefined') {
    try {
      choices = new Choices(select, {
        removeItemButton: id === "categories",
        searchEnabled: true,
        placeholderValue: placeholder,
        searchPlaceholderValue: "Buscar",
        shouldSort: false,
      });
    } catch (error) {
      console.warn('Error initializing Choices.js:', error);
      choices = null;
    }
  }
  
  if (id === "state") {
    stateChoices = choices;
    if (choices) {
      choices.setChoiceByValue("barinas"); // Set Barinas as default state
    } else {
      select.value = "barinas";
    }
  }
  if (id === "origin_state") {
    if (choices) {
      choices.setChoiceByValue("barinas"); // Set Barinas as default origin
    } else {
      // Fallback: set default option directly
      select.value = "barinas";
    }
  }
  if (id === "vehicle") vehicleChoices = choices;
  if (id === "categories") categoryChoices = choices;
}

populateSelect("state", data.state, "Selecciona un estado");
populateSelect("origin_state", data.state, "Selecciona estado de origen");
populateSelect("vehicle", data.vehicle, "Selecciona un vehículo");
populateSelect("categories", data.category, "Selecciona equipos");

// Auto-detect product category from page
const detectedCategory = detectProductCategory();
if (detectedCategory) {
  if (categoryChoices) {
    categoryChoices.setChoiceByValue(detectedCategory);
  } else {
    // Fallback: set directly on select element
    const categoriesSelect = document.getElementById("categories");
    if (categoriesSelect) {
      categoriesSelect.value = detectedCategory;
    }
  }
}

// Auto-enable ferry for Nueva Esparta and auto-recalculate
const stateElement = document.getElementById("state");
if (stateElement) {
  stateElement.addEventListener("change", function () {
    selectedState = this.value;
    const distanceElement = distanceInput ? distanceInput.parentElement : null;

    if (selectedState === "other") {
      if (distanceElement) distanceElement.style.display = "flex";
    } else {
      if (distanceElement) distanceElement.style.display = "none";
      // Set default kilometers based on selected state
      if (distanceInput) {
        const state = data.state.find((s) => s.value === selectedState);
        if (state) {
          distanceInput.value = state.distance;
        }
      }
    }

    // Handle ferry and load lift restrictions based on vehicle type
    if (selectedVehicle === "avion") {
      if (ferryCheckbox) {
        ferryCheckbox.checked = false;
        ferryCheckbox.disabled = true;
      }
      if (montaCargasCheckbox) {
        montaCargasCheckbox.checked = false;
        montaCargasCheckbox.disabled = true;
      }
    } else if (selectedVehicle === "barco") {
      if (ferryCheckbox) {
        ferryCheckbox.checked = false;
        ferryCheckbox.disabled = false;
      }
      if (montaCargasCheckbox) {
        montaCargasCheckbox.checked = false;
        montaCargasCheckbox.disabled = true;
      }
    } else {
      if (this.value === "nueva_esparta") {
        if (ferryCheckbox) {
          ferryCheckbox.checked = true;
          ferryCheckbox.disabled = true;
        }
      } else {
        if (ferryCheckbox) {
          ferryCheckbox.checked = false;
          ferryCheckbox.disabled = false;
        }
      }
      if (montaCargasCheckbox) {
        montaCargasCheckbox.checked = false;
        montaCargasCheckbox.disabled = false;
      }
    }
    
    // Auto-recalculate when state changes
    setTimeout(calculate, 100);
  });
}

// --- Restriction Logic ---
const vehicleElement = document.getElementById("vehicle");
if (vehicleElement) {
  vehicleElement.addEventListener("change", function () {
    selectedVehicle = this.value;
    const vehicle = data.vehicle.find((v) => v.value === selectedVehicle);

    // Don't filter categories - let user select any equipment
    // Validation warnings will be shown during calculation if incompatible
  
    // Handle special vehicle restrictions
    if (selectedVehicle === "avion") {
      // Air transport - disable ferry and load lift
      if (ferryCheckbox) {
        ferryCheckbox.checked = false;
        ferryCheckbox.disabled = true;
      }
      if (montaCargasCheckbox) {
        montaCargasCheckbox.checked = false;
        montaCargasCheckbox.disabled = true;
      }
      // Disable distance input for air transport
      if (distanceInput) {
        distanceInput.disabled = true;
        distanceInput.value = "";
      }
    } else {
      // Ground transport
      if (selectedState === "nueva_esparta") {
        if (ferryCheckbox) {
          ferryCheckbox.checked = true;
          ferryCheckbox.disabled = true;
        }
      } else {
        if (ferryCheckbox) {
          ferryCheckbox.checked = false;
          ferryCheckbox.disabled = false;
        }
      }
      if (montaCargasCheckbox) {
        montaCargasCheckbox.checked = false;
        montaCargasCheckbox.disabled = false;
      }
    }
    
    // Don't auto-calculate - only calculate on button click
  });
}

const categoriesElement = document.getElementById("categories");
if (categoriesElement) {
  categoriesElement.addEventListener("change", function () {
    const selected = [...this.selectedOptions].map((o) => o.value);
    const selectedCats = data.category.filter((c) => selected.includes(c.value));

    // Don't filter vehicles - let user select any vehicle
    // Validation warnings will be shown during calculation if incompatible
    
    // Don't auto-calculate - only calculate on button click
    checkAndSetInstallation();
  });
}

// Removed auto-calculation - calculations only happen on button click
// if (ferryCheckbox) ferryCheckbox.addEventListener("change", () => setTimeout(calculate, 100));
// if (montaCargasCheckbox) montaCargasCheckbox.addEventListener("change", () => setTimeout(calculate, 100));
// if (installationCheckbox) installationCheckbox.addEventListener("change", () => setTimeout(calculate, 100));
// if (distanceInput) distanceInput.addEventListener("input", () => setTimeout(calculate, 100));

// Add event listener for editable distance input - but don't auto-calculate
document.addEventListener("input", (e) => {
  if (e.target && e.target.id === "editable_distance") {
    // Don't auto-calculate - only calculate on button click
  }
});

// Add manual trigger for calculate button
document.addEventListener("click", (e) => {
  if (e.target && (e.target.id === "calculate" || e.target.textContent.includes("Calcular") || e.target.textContent.includes("calcular"))) {
    console.log("Calculate button clicked");
    calculate();
  }
});

// Auto-select installation for heavy equipment
function checkAndSetInstallation() {
  const categoriesElement = document.getElementById("categories");
  if (!categoriesElement || !installationCheckbox) return;
  
  const selectedCats = [...categoriesElement.selectedOptions].map((o) => o.value);
  const selectedEquipment = data.category.filter(cat => selectedCats.includes(cat.value));
  
  // Check if any heavy equipment is selected
  const hasHeavyEquipment = selectedEquipment.some(eq => 
    eq.value === "tomografo_listo" || 
    eq.value === "mamografo" || 
    eq.value === "rx_estacionario"
  );
  
  if (hasHeavyEquipment) {
    installationCheckbox.checked = true;
    installationCheckbox.disabled = true;
  } else {
    installationCheckbox.disabled = false;
  }
}

// --- Calculation ---
function calculate() {
  console.log("Calculate function called");
  let totalCost = 0;
  let viaticoCost = 0;
  
  const stateElement = document.getElementById("state");
  const originStateElement = document.getElementById("origin_state");
  const vehicleElement = document.getElementById("vehicle");
  const categoriesElement = document.getElementById("categories");
  
  console.log("Elements found:", {
    state: !!stateElement,
    originState: !!originStateElement,
    vehicle: !!vehicleElement,
    categories: !!categoriesElement
  });
  
  if (!stateElement || !vehicleElement || !categoriesElement) {
    console.log("Missing required elements, returning");
    return;
  }
  
  // Origin state is optional - use default if not found
  if (!originStateElement) {
    console.log("Origin state element not found, using default 'barinas'");
  }
  
  const stateVal = stateElement.value;
  const originStateVal = originStateElement ? originStateElement.value : "barinas"; // Default to Barinas
  const vehicleVal = vehicleElement.value;
  
  console.log("Values:", { stateVal, originStateVal, vehicleVal });
  
  // Get selected categories - handle both Choices.js and regular select
  let selectedCats = [];
  if (categoryChoices) {
    selectedCats = categoryChoices.getValue(true) || [];
    console.log("Selected categories from Choices.js:", selectedCats);
  } else {
    selectedCats = [...categoriesElement.selectedOptions].map((o) => o.value);
    console.log("Selected categories from regular select:", selectedCats);
  }
  
  const includeInstall = installationCheckbox ? installationCheckbox.checked : false;
  const includeMontaCargas = montaCargasCheckbox ? montaCargasCheckbox.checked : false;
  const includeFerry = ferryCheckbox ? ferryCheckbox.checked : false;

  console.log("Checkboxes:", { includeInstall, includeMontaCargas, includeFerry });

  // Validation checks
  if (!stateVal || !vehicleVal || selectedCats.length === 0) {
    console.log("Validation failed:", { stateVal, vehicleVal, selectedCatsLength: selectedCats.length });
    showValidationError("Por favor selecciona estado, vehículo y al menos un equipo.");
    return;
  }

  if (stateVal === "other" && distanceInput && getShippingDay(distanceInput.value) === -1) {
    alert("Por favor ingresa una distancia válida (0-1250 km).");
    return;
  }

  const state = data.state.find((s) => s.value === stateVal);
  const vehicle = data.vehicle.find((v) => v.value === vehicleVal);
  
  console.log("Found state and vehicle:", { state: !!state, vehicle: !!vehicle });
  
  if (!state || !vehicle) {
    console.log("State or vehicle not found");
    showValidationError("Estado o vehículo no encontrado.");
    return;
  }
  
  // Validate vehicle capacity before calculation
  console.log("Validating vehicle capacity...");
  if (!validateVehicleCapacity(selectedCats, vehicle)) {
    console.log("Vehicle capacity validation failed");
    return;
  }
  
  console.log("Starting calculation...");
  // Calculate capacity usage
  const capacityInfo = calculateCapacityUsage(selectedCats, vehicle);
  const requiredVehicles = calculateRequiredVehicles(selectedCats, vehicle);

  // Calculate viatico cost based on vehicle type and distance
  if (vehicle.value === "avion") {
    // Air transport - no viatico cost
    viaticoCost = 0;
  } else if (vehicle.value === "barco") {
    // Sea transport - reduced viatico cost
    if (state.value === "other" && distanceInput) {
      const dist = parseFloat(distanceInput.value) || 0;
      const shippingDay = getShippingDay(dist);
      viaticoCost = shippingDay === 1 ? 80 : shippingDay === 2 ? 95 : shippingDay === 3 ? 125 : 0;
    } else {
      viaticoCost = state.shipping_day === 1 ? 80 : state.shipping_day === 2 ? 95 : state.shipping_day === 3 ? 125 : 0;
    }
  } else {
    // Ground transport (auto, pickup, camion)
    if (state.value === "other" && distanceInput) {
      const dist = parseFloat(distanceInput.value) || 0;
      const shippingDay = getShippingDay(dist);
      viaticoCost = shippingDay === 1 ? 160 : shippingDay === 2 ? 190 : shippingDay === 3 ? 250 : 0;
    } else {
      viaticoCost = state.shipping_day === 1 ? 160 : state.shipping_day === 2 ? 190 : state.shipping_day === 3 ? 250 : 0;
    }
  }

  // Set multiplier based on vehicle type
  let multiplier = 1;
  if (vehicle.value === "avion") {
    multiplier = 0.5; // Air transport is more efficient for long distances
  } else if (vehicle.value === "barco") {
    multiplier = 1.2; // Sea transport slightly more expensive
  } else {
    multiplier = 1; // Ground transport standard rate
  }

  // Calculate distance from origin to destination
  const originState = data.state.find((s) => s.value === originStateVal);
  
  if (!originState) {
    console.log("Origin state not found in data, using Barinas as fallback");
    // Use Barinas as fallback
    const fallbackOrigin = data.state.find((s) => s.value === "barinas");
    if (!fallbackOrigin) {
      console.log("Barinas not found in data either");
      return;
    }
    // Continue with fallback - we'll use the fallbackOrigin for distance calculation
  }
  
  let distance = 0;
  
  // Check if there's an editable distance input from previous calculation
  const editableDistance = document.getElementById("editable_distance");
  let manualDistance = null;
  
  if (editableDistance && editableDistance.value && parseFloat(editableDistance.value) > 0) {
    // Preserve manually entered distance
    manualDistance = parseFloat(editableDistance.value);
    distance = manualDistance;
  } else if (state.value === "other" && distanceInput && distanceInput.value) {
    // Use distance input for "other" state
    distance = parseFloat(distanceInput.value) || 0;
  } else {
    // Calculate distance between origin and destination states
    const effectiveOriginState = originState || data.state.find((s) => s.value === "barinas");
    if (!effectiveOriginState) {
      console.log("No origin state available for distance calculation");
      return;
    }
    distance = Math.abs(state.distance - effectiveOriginState.distance);
  }
  
  // Distance and capacity warning logic
  let resultsHTML = "";
  
  // Capacity estimation warning
  resultsHTML += `<div class="shipping_result">
    <div class="capacity_warning" style="background-color: #fff3cd; color: #856404; padding: 10px; border-radius: 5px; margin-bottom: 10px; border-left: 4px solid #ffc107;">
      <strong>⚠️ Advertencia de Capacidad:</strong> Las estimaciones de capacidad son aproximadas y pueden variar según el equipo específico, embalaje y condiciones de transporte. 
      Consulta con nuestro equipo técnico para confirmar la viabilidad del envío.
    </div>
  </div>`;
  
  // Capacity warnings
  if (capacityInfo.isOverloaded) {
    resultsHTML = `<div class="shipping_result">
      <div class="warning_for_capacity" style="background-color: #ffebee; color: #c62828; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
        <strong>⚠️ Advertencia de Capacidad:</strong> Este vehículo quiza no puede transportar el equipo seleccionado de forma segura. 
      </div>`;
  } else if (capacityInfo.itemUsage > 80) {
    resultsHTML = `<div class="shipping_result">
      <div class="warning_for_capacity" style="background-color: #fff3e0; color: #ef6c00; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
        <strong>⚠️ Alto Uso de Capacidad:</strong> El vehículo está ${capacityInfo.itemUsage.toFixed(1)}% lleno. Considera usar un vehículo más grande para mejor eficiencia.
      </div>`;
  } else {
    resultsHTML = `<div class="shipping_result">`;
  }
  
  // Distance warnings
  if (distance > 700 && (vehicle.value === "auto" || vehicle.value === "pickup")) {
    resultsHTML += `<div class="warning_for_distance" style="background-color: #e3f2fd; color: #1565c0; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
      <strong>💡 Recomendación de Distancia:</strong> Para distancias superiores a 700km, considera usar Camión, Barco, o Avión para mejor eficiencia y seguridad.
      </div>`;
  } else if (distance > 1200 && vehicle.value.includes("camion")) {
    resultsHTML += `<div class="warning_for_distance" style="background-color: #e3f2fd; color: #1565c0; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
      <strong>💡 Recomendación de Distancia:</strong> Para distancias superiores a 1200km, considera usar Barco o Avión para mejor eficiencia.
      </div>`;
  }
  resultsHTML += `<div class="shipping_result_row">
                    <text>Origen:</text>
                    <text>${(originState || data.state.find((s) => s.value === "barinas"))?.name || "Barinas"}</text>
                  </div>
                  <div class="shipping_result_row">
                    <text>Destino:</text>
                    <text>${state.name}</text>
                  </div>
                  <div class="shipping_result_row">
                    <text>Distancia Estimada:</text>
                    <text><input type="number" id="editable_distance" value="${manualDistance || distance}" min="0" max="2000" style="width: 80px; padding: 2px; border: 1px solid #ccc; border-radius: 3px;" /> km</text>
                  </div>
                  <div class="shipping_result_row">
                    <text>Método de Envío:</text>
                    <text>${vehicle.name}${requiredVehicles > 1 ? ` (${requiredVehicles} vehículos necesarios)` : ''}</text>
                  </div>
                  <div class="shipping_result_row">
                    <text>Uso de Capacidad:</text>
                    <text>${capacityInfo.totalItems}/${capacityInfo.maxItems} equipos (${capacityInfo.itemUsage.toFixed(1)}%)</text>
                  </div>
                  <div class="shipping_result_row">
                    <text>Días de Viáticos Estimados:</text>
                    <text>${
                      state.value === "other" && distanceInput
                        ? getShippingDay(distanceInput.value)
                        : state.shipping_day
                    }${state.shipping_day < 2 ? "Día" : "Días"}
                    </text>
                  </div>
                  <div class="divider">
                </div>`;
  // Calculate base vehicle cost (multiplied by number of vehicles needed)
  const baseVehicleCost = vehicle.basePrice * requiredVehicles;
  totalCost += baseVehicleCost;
  
  resultsHTML += `<div class="shipping_result_row">
                    <text>Costo Base del Vehículo (${requiredVehicles} ${vehicle.name}${requiredVehicles > 1 ? 's' : ''}):</text>
                    <text>${baseVehicleCost.toFixed(2)} USD</text>
                  </div>`;
  
  selectedCats.forEach((catVal) => {
    const cat = data.category.find((c) => c.value === catVal);
    
    // New kilometer-based pricing formula (pure transport cost)
    const distanceCost = distance * vehicle.price * cat.equipmentFactor;
    const specialHandlingSurcharge = cat.requiresSpecialHandling ? cat.shipping_price * 0.05 : 0; // 5% surcharge for special handling
    
    let cost = distanceCost + specialHandlingSurcharge + viaticoCost;
    
    // Don't add installation to equipment cost - will be added separately
    // Don't add monta cargas to equipment cost - will be added separately
    // Don't add ferry to equipment cost - will be added separately
    totalCost += cost;
    
    // Create detailed cost breakdown
    const costBreakdown = [];
    costBreakdown.push(`Transporte (${distance}km): ${distanceCost.toFixed(2)} USD`);
    if (specialHandlingSurcharge > 0) {
      costBreakdown.push(`Manejo Especial: ${specialHandlingSurcharge.toFixed(2)} USD`);
    }
    if (viaticoCost > 0) {
      costBreakdown.push(`Viáticos: ${viaticoCost.toFixed(2)} USD`);
    }
    
    resultsHTML += `<div class="shipping_result_row">
                      <text>${cat.name}:</text> 
                      <text>${cost.toFixed(2)} USD</text>
                    </div>
                    <div class="shipping_result_row" style="margin-left: 20px; font-size: 0.9em; color: #666;">
                      <text>${costBreakdown.join(' + ')}</text>
                    </div>`;
  });
  
  // Add installation cost as separate line if selected
  if (includeInstall) {
    const totalInstallationCost = selectedCats.reduce((sum, catVal) => {
      const cat = data.category.find((c) => c.value === catVal);
      return sum + cat.installation_price;
    }, 0);
    totalCost += totalInstallationCost;
    resultsHTML += `<div class="shipping_result_row">
                      <text>Instalación:</text> 
                      <text>${totalInstallationCost.toFixed(2)} USD</text>
                    </div>`;
  }
  
  // Add warning for equipment without installation
  const equipmentWithoutInstallation = selectedCats.filter(catVal => {
    const cat = data.category.find((c) => c.value === catVal);
    return cat && cat.installation_price === 0;
  });
  
  if (equipmentWithoutInstallation.length > 0 && includeInstall) {
    const equipmentNames = equipmentWithoutInstallation.map(catVal => {
      const cat = data.category.find((c) => c.value === catVal);
      return cat ? cat.name : catVal;
    });
    
    resultsHTML += `<div class="shipping_result">
      <div class="installation_warning" style="background-color: #fff3cd; color: #856404; padding: 10px; border-radius: 5px; margin-bottom: 10px; border-left: 4px solid #ffc107;">
        <strong>⚠️ Advertencia de Instalación:</strong> Los siguientes equipos posiblemente no requieren instalación: ${equipmentNames.join(", ")}. 
        El costo de instalación solo se aplica a equipos que lo requieren.
      </div>
    </div>`;
  }
  
  // Add monta cargas cost as separate line if selected
  if (includeMontaCargas) {
    const montaCargasCost = data.extra.find((e) => e.name === "monta_cargas").price;
    totalCost += montaCargasCost;
    resultsHTML += `<div class="shipping_result_row">
                      <text>Monta Cargas:</text> 
                      <text>${montaCargasCost.toFixed(2)} USD</text>
                    </div>`;
  }
  
  // Add ferry cost as separate line if selected
  if (includeFerry) {
    const ferryCost = data.extra.find((e) => e.name === "ferry").price;
    totalCost += ferryCost;
    resultsHTML += `<div class="shipping_result_row">
                      <text>Ferry:</text> 
                      <text>${ferryCost.toFixed(2)} USD</text>
                    </div>`;
  }
  resultsHTML += `<div class="divider">
                </div>
                <div class="shipping_result_row">
                  <text>Costo Total Estimado:</text>
                  <text>${totalCost.toFixed(2)} USD
                  </text>
                </div>
              </div>`;
  const resultsElement = document.getElementById("results");
  if (resultsElement) {
    resultsElement.innerHTML = resultsHTML;
    resultsElement.style.display = "block";
    console.log("Results displayed successfully");
  } else {
    console.log("Results element not found");
  }
  console.log("Calculate function completed");
}

// Make calculate function globally accessible
window.calculateShipping = calculate;

// Also expose it as calculate for backward compatibility
window.calculate = calculate;
